export const white = '#ffffff',
  black = '#000000';
